import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bi bi-sun-fill"
}
const _hoisted_2 = {
  key: 1,
  class: "bi bi-moon-stars-fill"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-center align-items-center justify-content-center theme-toggle", { 'theme-toggle-light': _ctx.theme === 'light' }]),
    id: "themeToggle",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeTheme && _ctx.changeTheme(...args)))
  }, [
    (_ctx.theme == 'light')
      ? (_openBlock(), _createElementBlock("i", _hoisted_1))
      : (_openBlock(), _createElementBlock("i", _hoisted_2))
  ], 2))
}